module.exports = __webpack_public_path__ + "img/email-temp-jj.af5b0cf1.png";